import { render } from "./AdminAIReviewView.vue?vue&type=template&id=315f51e0&scoped=true"
import script from "./AdminAIReviewView.vue?vue&type=script&lang=js"
export * from "./AdminAIReviewView.vue?vue&type=script&lang=js"

import "./AdminAIReviewView.vue?vue&type=style&index=0&id=315f51e0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-315f51e0"]])

export default __exports__